import { MdlDialogReference, MdlDialogService } from '@angular-mdl/core';
import { ChangeDetectionStrategy, Component, Inject, InjectionToken } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AnnouncementInfo } from './announcement-info';
import { AnnouncementsInfoStorage } from './announcements-info-storage';

export const ANNOUNCEMENT_DELETE_TOKEN = new InjectionToken('AnnouncementDeleteItem');

@Component({
    selector: 'delete-announcement-dialog',
    template: require('./delete-announcement-dialog.component.html'),
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AnnouncementDeleteDialogComponent {
    public readonly editorForm: FormGroup;
    public readonly reasonControl = new FormControl(null);

    constructor(
        private readonly dialog: MdlDialogReference,
        private readonly dialogService: MdlDialogService,
        private readonly announcementsInfoStorage: AnnouncementsInfoStorage,
        @Inject(ANNOUNCEMENT_DELETE_TOKEN) readonly deletedAnnouncement: AnnouncementInfo
    ) {
        this.editorForm = new FormGroup({
            'reason': this.reasonControl
        });
    }

    public async onDelete() {
        const confirmed = await this.showConfirm(`The announcement will be deleted. Proceed?`);

        if (confirmed) {
            try {
                this.editorForm.disable();

                await this.announcementsInfoStorage.deleteAnnouncement(this.deletedAnnouncement, this.reasonControl.value as string);

                this.dialog.hide();
            } catch (e) {
                this.editorForm.enable();
                throw e;
            }
        }
    }

    public onCancel() {
        this.dialog.hide();
    }

    private async showConfirm(confirmationText: string): Promise<boolean> {
        try {
            await this.dialogService.confirm(confirmationText, 'No', 'Yes').toPromise();
            return true;
        } catch {
            return false;
        }
    }
}
